module.exports = __webpack_public_path__ + "img/L2.de4a4963.png";